import React from "react";
import ClientActions from "./ClientActions";

const ClientTableRow = ({ client, index, permissions, onDelete }) => {
  if (!client.accounts || client.accounts.length === 0) {
    return null;
  }
  
  return (
    <>
      {client.accounts.map((account, i) => (
        <tr key={`${index}-${i}`} role="row" className="odd">
          {i === 0 && (
            <td rowSpan={client.accounts.length}>
              {client.client?.identite?.raison_sociale ||
                `${client.client?.identite?.lastname || ""} ${client.client
                  ?.identite?.firstname || ""}`}
            </td>
          )}

          {i === 0 && (
            <td rowSpan={client.accounts.length}>
              {client.client?.identite?.telephone?.length > 0
                ? client.client.identite.telephone.map((tel, index, array) =>
                    index === array.length - 1 ? tel : `${tel} / `
                  )
                : null}
            </td>
          )}

          {i === 0 && (
            <td rowSpan={client.accounts.length}>
              {client.client?.identite?.email?.length > 0
                ? client.client.identite.email.map((mail, index, array) =>
                    index === array.length - 1 ? mail : `${mail} / `
                  )
                : null}
            </td>
          )}

          <td>{account.number}</td>
          <td>{client.institution ? client.institution.name : "-"}</td>

          <ClientActions
            accountId={account.id}
            index={index}
            permissions={permissions}
            onDelete={onDelete}
          />
        </tr>
      ))}
    </>
  );
};

export default ClientTableRow;
